const TEXT_FIELD = {
    SIZE: {
        SMALL: 'small',
        MEDIUM: 'medium'
    }
}

export { TEXT_FIELD }